import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

const Profile = () => {
  const { isAuthenticated, getIdTokenClaims } = useAuth0();
  const [profileData, setProfileData] = useState(null);

  useEffect(() => {
    if (isAuthenticated) {
      // Fetch ID Token Claims
      getIdTokenClaims().then((claims) => {
        setProfileData(claims);
      });
    }
  });

  if (!isAuthenticated) {
    return <h2>Please log in to view your profile.</h2>;
  }

  return (
    <div>
      <h1>Profile</h1>
      {profileData ? (
        <div>
          <p>Name: {profileData.name}</p>
          <p>Email: {profileData.email}</p>
          <img src={profileData.picture} alt="User" />
        </div>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
};

export default Profile;
